import React from "react";
import { ProjectDetailPageContent, ProjectDetailPageStateProvider } from ".";

export const ProjectDetailPage = () => {
  return (
    <ProjectDetailPageStateProvider>
      <ProjectDetailPageContent></ProjectDetailPageContent>
    </ProjectDetailPageStateProvider>
  );
};
